/** Applications SEmply clientes du portail d'authentification. */
export const SEMPLY_APPS = {
    APP: 'semply-app',
    COMPTA: 'semply-compta',
    PREVI: 'semply-previ',
};
export const SEMPLY_APP_LABELS = {
    [SEMPLY_APPS.APP]: 'SEmplyApp',
    [SEMPLY_APPS.COMPTA]: 'SEmplyCompta',
    [SEMPLY_APPS.PREVI]: 'SEmplyPrevi',
};
//# sourceMappingURL=apps.js.map